import { Button, Group, Text } from '@mantine/core';
import type { MatchSuggestion } from '../../types';

type SelectionActionsProps = {
  selected: MatchSuggestion[];
  onConfirm?: () => void;
  onReject?: () => void;
  onUnlink?: () => void;
  onReopen?: () => void;
  onClear: () => void;
  loading?: boolean;
};

export default function SelectionActions({
  selected,
  onConfirm,
  onReject,
  onUnlink,
  onReopen,
  onClear,
  loading = false,
}: SelectionActionsProps) {
  const statuses = new Set(selected.map(s => s.status));
  const allPending = statuses.size === 1 && statuses.has('PENDING');
  const allConfirmed = statuses.size === 1 && statuses.has('CONFIRMED');
  const allReopenable =
    statuses.size > 0 && [...statuses].every(s => s === 'REJECTED' || s === 'UNLINKED');

  return (
    <Group gap="xs">
      <Text size="sm" c="dimmed">
        {selected.length} selected
      </Text>
      {allPending && onConfirm && (
        <Button size="sm" onClick={onConfirm} loading={loading}>
          Confirm
        </Button>
      )}
      {allPending && onReject && (
        <Button size="sm" color="red" variant="light" onClick={onReject} loading={loading}>
          Reject
        </Button>
      )}
      {allConfirmed && onUnlink && (
        <Button size="sm" color="gray" variant="light" onClick={onUnlink} loading={loading}>
          Unlink
        </Button>
      )}
      {allReopenable && onReopen && (
        <Button size="sm" color="gray" variant="light" onClick={onReopen} loading={loading}>
          Reopen
        </Button>
      )}
      <Button size="sm" variant="subtle" onClick={onClear} disabled={loading}>
        Clear
      </Button>
    </Group>
  );
}
